"use client";

import { useSidebar } from '@/app/context/SidebarContext';
import SidebarNavigation from './SidebarNavigation';
import UserMenu from './UserMenu';
import useBootstrapTooltips from '@/app/hooks/useBootstrapTooltips';

const Header = () => {
  const { isCollapsed, toggleCollapse, hydrated } = useSidebar();

  useBootstrapTooltips();

  // Avoid hydration mismatch — render collapsed until client-side state loads
  const collapsed = !hydrated || isCollapsed;

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : 'expanded'}`}>
      {/* Top: Logo */}
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <img src="/images/icons/muster-icon.png" alt="Muster" className="sidebar-logo-img" />
          {!collapsed && <span className="sidebar-logo-text">Muster</span>}
        </div>
      </div>

      {/* Middle: Navigation */}
      <SidebarNavigation />

      {/* Bottom: Toggle + User */}
      <div className="sidebar-footer">
        <button
          className="sidebar-toggle"
          onClick={toggleCollapse}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          {...(collapsed ? {
            'data-bs-toggle': 'tooltip',
            'data-bs-placement': 'right',
            title: 'Expand menu',
          } : {})}
        >
          <svg
            aria-hidden="true"
            focusable="false"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            className={`toggle-chevron ${collapsed ? '' : 'flipped'}`}
          >
            <path
              d="M6 3L11 8L6 13"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {!collapsed && <span className="sidebar-toggle-label">Collapse</span>}
        </button>
        <UserMenu />
      </div>
    </aside>
  );
};

export default Header;
